import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/statusService";
const store = {};
const mutations = {
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.statusDetail = posts.data;
            state.statusDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_STATUS_LIST(state, posts) {
        state.statusList = posts;
        state.statusListIsLoading = false;
    },
    SET_STATUS_LIST_SIMPLE(state, posts) {
        state.statusListSimple = posts;
        state.statusListSimpleIsLoading = false;
    },
    SET_STATUS_LIST_WITH_TTY(state, posts) {
        state.statusListWithTty = posts;
        state.statusListWithTtyIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.statusDetailChanged = false;

        }
        else {
            alert(posts.errorMessage);
        }
    },
    DELETE_STATUS(state) {
        state.statusDeleted = true;
    },
    GET_STATUS_INFO() {
    },
    SAVE_ACCESSLIST_FOR_STATUS(state, posts) {
        if (posts.success == true) {
            state.accessListForStatusChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_ACCESSLIST_FOR_STATUS(state, posts) {
        state.accessListForStatusIsLoading = false;
        if (posts.success == true) {
            state.accessListForStatus = posts.wfAccessList;
            state.accessListForStatusChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_ACTIONLIST_FOR_STATUS(state, posts) {
        if (posts.success == true) {
            state.actionListForStatus = posts.list;
            state.currentTopicStatus = posts.currentStatus;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    CHANGE_TOPIC_STATUS() {

    },
    CHANGE_TOPICLINK_STATUS() {

    }
};
const state = {
    statusListIsLoading: false,
    statusList: [],
    accessListForStatusIsLoading: false,
    accessListForStatus: [],
    actionListForStatus: [],
    statusListSimpleIsLoading: false,
    statusListSimple: [],
    statusListWithTtyIsLoading: false,
    statusListWithTty: [],
    statusDetail: {},
    statusDetailChanged: false,
    accessListForStatusChanged: false,
    statusDeleted: false,
    currentTopicStatus: { StatusId: null, StatusName: '', StgId: null }
};
const getters = {};
const actions = {
    getStatusList({ commit }) {
        state.statusListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_STATUS_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getStatusListSimple({ commit }, { worId }) {
        state.statusListSimpleIsLoading = true;
        return axios
            .get(baseUri + '/GetListSimple?worId=' + worId)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_STATUS_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getStatusListWithTty({ commit }) {
        state.statusListWithTtyIsLoading = true;
        return axios
            .get(baseUri + '/GetListSimpleWithTtyId')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_STATUS_LIST_WITH_TTY', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getAccessListForStatus({ commit }, data) {
        state.accessListForStatusIsLoading = false;
        return axios
            .get(baseUri + '/GetAccessListForStatus?statusId=' + data.statusId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCESSLIST_FOR_STATUS', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getActionListByWorkflow({ commit }, data) {
        return axios
            .get(baseUri + '/GetActionListByWorkflow?args=' + data.args + '&topicId=' + data.topicId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACTIONLIST_FOR_STATUS', res.data);
                    return true;
                }
                else {
                    alert(res.data.errorMessage);
                    return false;
                }
            });
    },
    getStatusDetail({ commit }, data) {
        state.statusListIsLoading = true;
        var formData = new FormData();
        formData.append("statusId", data.statusId);
        formData.append("worId", data.worId);
        return axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getStatusInfo({ commit }, { statusId }) {
        return axios
            .get(baseUri + '/GetStatusInfo', { params: { statusId } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_STATUS_INFO', res.data);
                }
                return res;
            });
    },
    saveStatusDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.statusDetail));
        return axios
            .post(baseUri + '/Update', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
                return res;
            });
    },
    deleteStatus({ commit }, data) {
        var formData = new FormData();
        formData.append("statusId", data.statusId);

        return axios
            .post(baseUri + '/Delete', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('DELETE_STATUS');
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    saveAccessListForStatus({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.accessListForStatus));
        formData.append("statusId", state.statusDetail.StatusID);
        return axios
            .post(baseUri + '/SaveAccessListForStatus', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ACCESSLIST_FOR_STATUS', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
                return res;
            });
    },
    changeTopicStatus({ commit }, { topicId, statusId, mailText, assigneeId, expertIds }) {
        var formData = new FormData();
        if (typeof expertIds === 'undefined') { expertIds = [] }
        formData.append("TopicId", topicId);
        formData.append("StatusId", statusId);
        formData.append("AssigneeId", assigneeId);
        formData.append("MailText", mailText);
        formData.append("ExpertIds", expertIds);
        return axios
            .post(baseUri + '/ChangeTopicStatus', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('CHANGE_TOPIC_STATUS', res.data);
                    return res.data;
                }
                else {
                    alert(res.data.Error);
                    return res.data;
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}